import type { ProductReviewInfo, PageInfo } from '@@partner:types:app'
import type {
  CommonPager,
  NestedFilter,
  CommonSort
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import {
  SHORTCUT_PAGE_INFO_FIELDS,
  PRODUCT_REVIEW_FIELDS
} from '@@partner:graphql/shortcuts'

export interface AllProductReviewsQuery {
  productReviews: {
    edges: ProductReviewInfo[]
    pageInfo: PageInfo
  }
}
export interface AllProductReviewsQueryVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_ALL_PRODUCT_REVIEWS = gql`
  query (
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    productReviews: allProductReviews(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
    edges {
      ${PRODUCT_REVIEW_FIELDS}
      customer {
        id
        first_name
        last_name
      }
      product {
        id
        xid
        name
        preview {
         url
        }
      }
    }
    pageInfo {
      ${SHORTCUT_PAGE_INFO_FIELDS}
    }
  }
}
`

export const useFetchAllProductReviews = (
  variables: AllProductReviewsQueryVariables
) =>
  useQuery<AllProductReviewsQuery, AllProductReviewsQueryVariables>(
    GQL_QUERY_ALL_PRODUCT_REVIEWS,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )
